// Translations
import landing from '../views/landing/translations/ua'

// Translation: Verification (Ukrainian)
export default Object.freeze({
	name: '',
	views: { landing }
})
